import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
    name: 'keys'
})
export class KeysPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        const keys = [];
        for (const key in value) {
            if (Object.prototype.hasOwnProperty.call(value, key)) {
                keys.push(key);
            }
        }
        return keys;
    }
}
